import { enumKeysToArray } from '@/utils/enum'
import { makeServicesTypes } from '@/core/container/makeServicesTypes'

enum SERVICES {
  ScheduledUpcomingBulkManager,
  ScheduledPausedBulkManager,
  ScheduledCompletedBulkManager,

  // Domain services
  ScheduledService,
  ScheduledParametersService,
  ScheduledCalendarEventService,
  ScheduledCalendarEventDetailsService,
  ScheduledContactMessageService,

  // Repositories
  ScheduledRepository,
  ScheduledShortRepository,
  ScheduledParametersRepository,
  ScheduledCalendarEventRepository,
  ScheduledCalendarEventDetailsRepository,
  ScheduledContactMessageRepository,
}

export type ScheduledServices = keyof typeof SERVICES

export const SCHEDULED_SERVICE_TYPES: Record<ScheduledServices, symbol> = makeServicesTypes<ScheduledServices>(
  enumKeysToArray<ScheduledServices>(SERVICES),
)
